<script setup lang="ts"></script>

<template>
  <div>
    <div>
      <h1>404</h1>
      <p>Página não encontrada</p>
      <p>A página que você está procurando não existe ou foi movida.</p>
      <router-link to="/dashboard">
        Voltar ao Dashboard
      </router-link>
    </div>
  </div>
</template>
